<div class="container-layout">
  <ods-top-navbar componentTitle="{{'topnavbar.title' | translate}}"></ods-top-navbar>

  <ta-maintenance></ta-maintenance>

</div>